export default __webpack_public_path__ + "static/media/arrow-backward.27ccc0b0.svg";